var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"address"},[_c('van-address-list',{attrs:{"list":_vm.list,"disabled-list":_vm.disabledList,"disabled-text":"以下地址超出配送范围"},on:{"add":_vm.onAdd,"edit":_vm.onEdit},model:{value:(_vm.chosenAddressId),callback:function ($$v) {_vm.chosenAddressId=$$v},expression:"chosenAddressId"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35be06fc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/address/addressList.vue
// module id = null
// module chunks = 